import { render, staticRenderFns } from "./FieldsRegister.vue?vue&type=template&id=25d3182f&"
import script from "./FieldsRegister.vue?vue&type=script&lang=js&"
export * from "./FieldsRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports